export function render(element: JSX.Element, container: Element | DocumentFragment | null) {
  import(/* webpackChunkName: "create-root" */'react-dom/client')
    .then(r => {
      if (!container) {
        return;
      }

      r.createRoot(container).render(element);
    });
}